import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "workspace-versions" }
const _hoisted_2 = { class: "version-field" }
const _hoisted_3 = ["value", "disabled"]
const _hoisted_4 = {
  class: "package-field",
  role: "group",
  "aria-label": "已安装扩展包"
}
const _hoisted_5 = {
  key: 0,
  class: "version-hint"
}
const _hoisted_6 = ["checked", "disabled", "onChange"]
const _hoisted_7 = {
  key: 0,
  class: "package-included"
}

import { computed } from "vue";
import StudioSelectField from "./StudioSelectField.vue";
import type { WorkspaceSettings } from "./workspaceSettings";
import { baseReleases } from "./versioning/baseReleases";
import { formatReleaseLabel } from "./versioning/types";
import { extensionPackages } from "./versioning/extensionPackages";
import { changeWorkspaceBase, cloneWorkspaceTarget, getBasePackageIds, workspaceTargetErrors } from "./versioning/catalog";


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkspaceVersionSettings',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    overlayTarget: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const bases = computed(() => [...baseReleases].sort((a, b) => b.order - a.order));
const includedPackageIds = computed(() => getBasePackageIds(props.modelValue.baseReleaseId));
const enabledPackageIds = computed(() => cloneWorkspaceTarget(props.modelValue).packageIds);
const errors = computed(() => workspaceTargetErrors(props.modelValue));
function changeBase(id: number | null) {
  if (props.disabled || id === null) return;
  emit("update:modelValue", { ...props.modelValue, ...changeWorkspaceBase(props.modelValue, id) });
}
function togglePackage(id: number, event: Event) {
  if (props.disabled || includedPackageIds.value.includes(id)) return;
  const checked = (event.target as HTMLInputElement).checked;
  emit("update:modelValue", { ...props.modelValue, packageIds: checked
    ? [...props.modelValue.packageIds.filter(value => value !== id), id]
    : props.modelValue.packageIds.filter(value => value !== id) });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "version-hint" }, "基准自带的扩展包自动启用；其他包请按实际安装情况选择。", -1)),
    _createElementVNode("label", _hoisted_2, [
      _cache[0] || (_cache[0] = _createTextVNode("基准版本 ", -1)),
      _createVNode(StudioSelectField, {
        "model-value": __props.modelValue.baseReleaseId,
        to: __props.overlayTarget ?? false,
        disabled: __props.disabled || !bases.value.length,
        "aria-label": "基准版本",
        "onUpdate:modelValue": changeBase
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bases.value, (base) => {
            return (_openBlock(), _createElementBlock("option", {
              key: base.id,
              value: base.id,
              disabled: !!base.fileTypes && !base.fileTypes.includes(__props.modelValue.fileType)
            }, _toDisplayString(_unref(formatReleaseLabel)(base)), 9, _hoisted_3))
          }), 128))
        ]),
        _: 1
      }, 8, ["model-value", "to", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "已安装扩展包", -1)),
      (!_unref(extensionPackages).length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "暂无可选扩展包"))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extensionPackages), (extension) => {
        return (_openBlock(), _createElementBlock("label", {
          key: extension.id,
          class: "package-option"
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: enabledPackageIds.value.includes(extension.id),
            disabled: __props.disabled || includedPackageIds.value.includes(extension.id),
            onChange: ($event: any) => (togglePackage(extension.id, $event))
          }, null, 40, _hoisted_6),
          _createTextVNode(" " + _toDisplayString(extension.name) + " ", 1),
          (includedPackageIds.value.includes(extension.id))
            ? (_openBlock(), _createElementBlock("small", _hoisted_7, "基准自带"))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (message) => {
      return (_openBlock(), _createElementBlock("p", {
        key: message,
        class: "version-error",
        role: "alert"
      }, _toDisplayString(message), 1))
    }), 128))
  ]))
}
}

})